import gql from 'graphql-tag';

export const GET_SERIES = gql`
  query GetSeries($query: SerieQuery!) {
    getSeries(query: $query) {
      _id
      name
    }
  }
`;
